import type { MultilingualQuestion } from '../../types/multilingualQuestion';

// Multilingual version of Technology & Safety questions
export const technologySafetyMultilingual: MultilingualQuestion[] = [
  {
    id: 'q-ts-1',
    text: {
      en: 'What does ABS (Anti-lock Braking System) do?',
      nl: 'Wat doet ABS (Anti-blokkeersysteem)?',
      ar: 'ماذا يفعل ABS (نظام الفرملة المانعة للانغلاق)؟'
    },
    options: [
      {
        id: 'q-ts-1o1',
        text: {
          en: 'Prevents the wheels from locking during braking',
          nl: 'Voorkomt dat de wielen blokkeren tijdens het remmen',
          ar: 'يمنع انغلاق العجلات أثناء الفرملة'
        }
      },
      {
        id: 'q-ts-1o2',
        text: {
          en: 'Automatically applies the brakes',
          nl: 'Past automatisch de remmen toe',
          ar: 'يطبق الفرامل تلقائيا'
        }
      },
      {
        id: 'q-ts-1o3',
        text: {
          en: 'Increases braking distance',
          nl: 'Vergroot de remafstand',
          ar: 'يزيد مسافة الفرملة'
        }
      },
      {
        id: 'q-ts-1o4',
        text: {
          en: 'Reduces fuel consumption',
          nl: 'Vermindert brandstofverbruik',
          ar: 'يقلل استهلاك الوقود'
        }
      }
    ],
    correctAnswerId: 'q-ts-1o1',
    explanation: {
      en: 'ABS (Anti-lock Braking System) prevents the wheels from locking during hard braking, allowing the driver to maintain steering control and reduce stopping distance.',
      nl: 'ABS (Anti-blokkeersysteem) voorkomt dat de wielen blokkeren tijdens hard remmen, waardoor de bestuurder de stuurcontrole kan behouden en de remafstand kan verminderen.',
      ar: 'ABS (نظام الفرملة المانعة للانغلاق) يمنع انغلاق العجلات أثناء الفرملة القوية، مما يسمح للسائق بالحفاظ على التحكم في التوجيه وتقليل مسافة التوقف.'
    },
    subject: 'Technology & Safety'
  },
  {
    id: 'q-ts-2',
    text: {
      en: 'What does ESP (Electronic Stability Program) do?',
      nl: 'Wat doet ESP (Elektronisch Stabiliteitsprogramma)?',
      ar: 'ماذا يفعل ESP (برنامج الاستقرار الإلكتروني)؟'
    },
    options: [
      {
        id: 'q-ts-2o1',
        text: {
          en: 'Controls the engine speed',
          nl: 'Regelt de motorsnelheid',
          ar: 'يتحكم في سرعة المحرك'
        }
      },
      {
        id: 'q-ts-2o2',
        text: {
          en: 'Helps maintain vehicle stability during cornering',
          nl: 'Helpt de stabiliteit van het voertuig te behouden tijdens het nemen van bochten',
          ar: 'يساعد في الحفاظ على استقرار المركبة أثناء الانعطاف'
        }
      },
      {
        id: 'q-ts-2o3',
        text: {
          en: 'Controls the air conditioning',
          nl: 'Regelt de airconditioning',
          ar: 'يتحكم في تكييف الهواء'
        }
      },
      {
        id: 'q-ts-2o4',
        text: {
          en: 'Manages the fuel injection',
          nl: 'Beheert de brandstofinjectie',
          ar: 'يدير حقن الوقود'
        }
      }
    ],
    correctAnswerId: 'q-ts-2o2',
    explanation: {
      en: 'ESP (Electronic Stability Program) helps maintain vehicle stability during cornering by automatically applying brakes to individual wheels when it detects loss of control.',
      nl: 'ESP (Elektronisch Stabiliteitsprogramma) helpt de stabiliteit van het voertuig te behouden tijdens het nemen van bochten door automatisch remmen toe te passen op individuele wielen wanneer het verlies van controle detecteert.',
      ar: 'ESP (برنامج الاستقرار الإلكتروني) يساعد في الحفاظ على استقرار المركبة أثناء الانعطاف من خلال تطبيق الفرامل تلقائيا على العجلات الفردية عند اكتشاف فقدان السيطرة.'
    },
    subject: 'Technology & Safety'
  },
  {
    id: 'q-ts-3',
    text: {
      en: 'What is a rear-view camera used for?',
      nl: 'Waar wordt een achteruitrijcamera voor gebruikt?',
      ar: 'ما هو استخدام كاميرا الرؤية الخلفية؟'
    },
    options: [
      {
        id: 'q-ts-3o1',
        text: {
          en: 'To watch movies while driving',
          nl: 'Om films te kijken tijdens het rijden',
          ar: 'لمشاهدة الأفلام أثناء القيادة'
        }
      },
      {
        id: 'q-ts-3o2',
        text: {
          en: 'To help with reversing and parking',
          nl: 'Om te helpen bij achteruitrijden en parkeren',
          ar: 'للمساعدة في الرجوع للخلف والوقوف'
        }
      },
      {
        id: 'q-ts-3o3',
        text: {
          en: 'To monitor traffic behind',
          nl: 'Om verkeer achter te monitoren',
          ar: 'لمراقبة المرور من الخلف'
        }
      },
      {
        id: 'q-ts-3o4',
        text: {
          en: 'To take photos while driving',
          nl: 'Om foto\'s te maken tijdens het rijden',
          ar: 'للتقاط الصور أثناء القيادة'
        }
      }
    ],
    correctAnswerId: 'q-ts-3o2',
    explanation: {
      en: 'A rear-view camera helps with reversing and parking by providing a clear view of the area behind the vehicle, reducing blind spots.',
      nl: 'Een achteruitrijcamera helpt bij achteruitrijden en parkeren door een duidelijk beeld te geven van het gebied achter het voertuig, waardoor dode hoeken worden verminderd.',
      ar: 'كاميرا الرؤية الخلفية تساعد في الرجوع للخلف والوقوف من خلال توفير رؤية واضحة للمنطقة خلف المركبة، مما يقلل من النقاط العمياء.'
    },
    subject: 'Technology & Safety'
  },
  {
    id: 'q-ts-4',
    text: {
      en: 'What does Adaptive Cruise Control (ACC) do?',
      nl: 'Wat doet Adaptieve Cruise Control (ACC)?',
      ar: 'ماذا يفعل التحكم التكيفي في السرعة (ACC)؟'
    },
    options: [
      {
        id: 'q-ts-4o1',
        text: {
          en: 'Automatically steers the vehicle',
          nl: 'Stuurt automatisch het voertuig',
          ar: 'يوجه المركبة تلقائيا'
        }
      },
      {
        id: 'q-ts-4o2',
        text: {
          en: 'Maintains a safe distance from the vehicle ahead',
          nl: 'Houdt een veilige afstand aan van het voertuig voor je',
          ar: 'يحافظ على مسافة آمنة من المركبة أمامك'
        }
      },
      {
        id: 'q-ts-4o3',
        text: {
          en: 'Automatically parks the vehicle',
          nl: 'Parkeert automatisch het voertuig',
          ar: 'يركن المركبة تلقائيا'
        }
      },
      {
        id: 'q-ts-4o4',
        text: {
          en: 'Controls the radio volume',
          nl: 'Regelt het radiovolume',
          ar: 'يتحكم في مستوى صوت الراديو'
        }
      }
    ],
    correctAnswerId: 'q-ts-4o2',
    explanation: {
      en: 'Adaptive Cruise Control (ACC) maintains a set speed while automatically adjusting to maintain a safe distance from the vehicle ahead.',
      nl: 'Adaptieve Cruise Control (ACC) handhaaft een ingestelde snelheid terwijl het automatisch aanpast om een veilige afstand te behouden van het voertuig voor je.',
      ar: 'التحكم التكيفي في السرعة (ACC) يحافظ على سرعة محددة مع التعديل التلقائي للحفاظ على مسافة آمنة من المركبة أمامك.'
    },
    subject: 'Technology & Safety'
  },
  {
    id: 'q-ts-5',
    text: {
      en: 'What does Lane Departure Warning (LDW) do?',
      nl: 'Wat doet Lane Departure Warning (LDW)?',
      ar: 'ماذا يفعل تحذير مغادرة الممر (LDW)؟'
    },
    options: [
      {
        id: 'q-ts-5o1',
        text: {
          en: 'Automatically steers the vehicle back into the lane',
          nl: 'Stuurt automatisch het voertuig terug in de rijstrook',
          ar: 'يوجه المركبة تلقائيا للعودة إلى الممر'
        }
      },
      {
        id: 'q-ts-5o2',
        text: {
          en: 'Warns the driver when the vehicle drifts out of the lane',
          nl: 'Waarschuwt de bestuurder wanneer het voertuig uit de rijstrook drijft',
          ar: 'يحذر السائق عندما تنحرف المركبة عن الممر'
        }
      },
      {
        id: 'q-ts-5o3',
        text: {
          en: 'Changes lanes automatically',
          nl: 'Wisselt automatisch van rijstrook',
          ar: 'يغير الممرات تلقائيا'
        }
      },
      {
        id: 'q-ts-5o4',
        text: {
          en: 'Controls the turn signals',
          nl: 'Regelt de richtingaanwijzers',
          ar: 'يتحكم في إشارات الانعطاف'
        }
      }
    ],
    correctAnswerId: 'q-ts-5o2',
    explanation: {
      en: 'Lane Departure Warning (LDW) warns the driver when the vehicle drifts out of the lane without using the turn signal.',
      nl: 'Lane Departure Warning (LDW) waarschuwt de bestuurder wanneer het voertuig uit de rijstrook drijft zonder gebruik te maken van de richtingaanwijzer.',
      ar: 'تحذير مغادرة الممر (LDW) يحذر السائق عندما تنحرف المركبة عن الممر دون استخدام إشارة الانعطاف.'
    },
    subject: 'Technology & Safety'
  },
  {
    id: 'q-ts-6',
    text: {
      en: 'What does Blind Spot Monitoring (BSM) do?',
      nl: 'Wat doet Blind Spot Monitoring (BSM)?',
      ar: 'ماذا يفعل مراقبة النقطة العمياء (BSM)؟'
    },
    options: [
      {
        id: 'q-ts-6o1',
        text: {
          en: 'Automatically changes lanes',
          nl: 'Wisselt automatisch van rijstrook',
          ar: 'يغير الممرات تلقائيا'
        }
      },
      {
        id: 'q-ts-6o2',
        text: {
          en: 'Warns of vehicles in the blind spot',
          nl: 'Waarschuwt voor voertuigen in de dode hoek',
          ar: 'يحذر من المركبات في النقطة العمياء'
        }
      },
      {
        id: 'q-ts-6o3',
        text: {
          en: 'Controls the mirrors',
          nl: 'Regelt de spiegels',
          ar: 'يتحكم في المرايا'
        }
      },
      {
        id: 'q-ts-6o4',
        text: {
          en: 'Adjusts the seat position',
          nl: 'Stelt de stoelpositie bij',
          ar: 'يضبط موضع المقعد'
        }
      }
    ],
    correctAnswerId: 'q-ts-6o2',
    explanation: {
      en: 'Blind Spot Monitoring (BSM) warns the driver of vehicles in the blind spot when changing lanes.',
      nl: 'Blind Spot Monitoring (BSM) waarschuwt de bestuurder voor voertuigen in de dode hoek bij het wisselen van rijstrook.',
      ar: 'مراقبة النقطة العمياء (BSM) تحذر السائق من المركبات في النقطة العمياء عند تغيير الممرات.'
    },
    subject: 'Technology & Safety'
  },
  {
    id: 'q-ts-7',
    text: {
      en: 'What does Autonomous Emergency Braking (AEB) do?',
      nl: 'Wat doet Autonome Noodremming (AEB)?',
      ar: 'ماذا يفعل الفرملة الطارئة المستقلة (AEB)؟'
    },
    options: [
      {
        id: 'q-ts-7o1',
        text: {
          en: 'Automatically applies brakes to prevent collisions',
          nl: 'Past automatisch remmen toe om botsingen te voorkomen',
          ar: 'يطبق الفرامل تلقائيا لمنع التصادمات'
        }
      },
      {
        id: 'q-ts-7o2',
        text: {
          en: 'Controls the steering wheel',
          nl: 'Regelt het stuurwiel',
          ar: 'يتحكم في عجلة القيادة'
        }
      },
      {
        id: 'q-ts-7o3',
        text: {
          en: 'Manages the fuel system',
          nl: 'Beheert het brandstofsysteem',
          ar: 'يدير نظام الوقود'
        }
      },
      {
        id: 'q-ts-7o4',
        text: {
          en: 'Adjusts the suspension',
          nl: 'Stelt de ophanging bij',
          ar: 'يضبط التعليق'
        }
      }
    ],
    correctAnswerId: 'q-ts-7o1',
    explanation: {
      en: 'Autonomous Emergency Braking (AEB) automatically applies the brakes to prevent or reduce the severity of a collision when it detects an imminent crash.',
      nl: 'Autonome Noodremming (AEB) past automatisch de remmen toe om een botsing te voorkomen of de ernst ervan te verminderen wanneer het een naderende crash detecteert.',
      ar: 'الفرملة الطارئة المستقلة (AEB) تطبق الفرامل تلقائيا لمنع التصادم أو تقليل شدته عند اكتشاف تصادم وشيك.'
    },
    subject: 'Technology & Safety'
  },
  {
    id: 'q-ts-8',
    text: {
      en: 'What does Tire Pressure Monitoring System (TPMS) do?',
      nl: 'Wat doet het Bandenspanningscontrolesysteem (TPMS)?',
      ar: 'ماذا يفعل نظام مراقبة ضغط الإطارات (TPMS)؟'
    },
    options: [
      {
        id: 'q-ts-8o1',
        text: {
          en: 'Automatically inflates the tires',
          nl: 'Pompt automatisch de banden op',
          ar: 'ينفخ الإطارات تلقائيا'
        }
      },
      {
        id: 'q-ts-8o2',
        text: {
          en: 'Warns of low tire pressure',
          nl: 'Waarschuwt voor lage bandenspanning',
          ar: 'يحذر من انخفاض ضغط الإطارات'
        }
      },
      {
        id: 'q-ts-8o3',
        text: {
          en: 'Changes the tires automatically',
          nl: 'Wisselt automatisch de banden',
          ar: 'يغير الإطارات تلقائيا'
        }
      },
      {
        id: 'q-ts-8o4',
        text: {
          en: 'Controls the suspension',
          nl: 'Regelt de ophanging',
          ar: 'يتحكم في التعليق'
        }
      }
    ],
    correctAnswerId: 'q-ts-8o2',
    explanation: {
      en: 'Tire Pressure Monitoring System (TPMS) warns the driver when tire pressure is too low, which can affect safety and fuel efficiency.',
      nl: 'Het Bandenspanningscontrolesysteem (TPMS) waarschuwt de bestuurder wanneer de bandenspanning te laag is, wat de veiligheid en brandstofefficiëntie kan beïnvloeden.',
      ar: 'نظام مراقبة ضغط الإطارات (TPMS) يحذر السائق عندما يكون ضغط الإطارات منخفضا جدا، مما قد يؤثر على السلامة وكفاءة الوقود.'
    },
    subject: 'Technology & Safety'
  }
  ,
  {
    id: 'q-ts-9',
    text: {
      en: 'What should you do when using cruise control on a wet or slippery road?',
      nl: 'Wat moet u doen als u cruise control gebruikt op een natte of gladde weg?',
      ar: 'ماذا يجب أن تفعل عند استخدام ثبات السرعة (Cruise Control) على طريق مبلّل أو زلق؟'
    },
    options: [
      { id: 'q-ts-9o1', text: { en: 'Increase the set speed for better control', nl: 'De ingestelde snelheid verhogen voor meer controle', ar: 'زِد السرعة المحددة للحصول على تحكم أفضل' } },
      { id: 'q-ts-9o2', text: { en: 'Switch off cruise control and drive manually', nl: 'Cruise control uitschakelen en handmatig rijden', ar: 'أوقف ثبات السرعة وقُد يدوياً' } },
      { id: 'q-ts-9o3', text: { en: 'Keep cruise control on; it improves grip', nl: 'Cruise control aan laten; dat verbetert de grip', ar: 'اترك ثبات السرعة يعمل؛ فهو يحسّن التماسك' } }
    ],
    correctAnswerId: 'q-ts-9o2',
    explanation: {
      en: 'On wet or slippery roads, you should switch off cruise control and drive manually. Cruise control can reduce your ability to respond quickly to changing conditions.',
      nl: 'Op natte of gladde wegen schakelt u cruise control uit en rijdt u handmatig. Cruise control kan uw vermogen verminderen om snel te reageren op veranderende omstandigheden.',
      ar: 'على الطرق المبللة أو الزلقة، يجب إيقاف ثبات السرعة والقيادة يدوياً. قد يقلّل ثبات السرعة قدرتك على الاستجابة بسرعة للتغيرات في ظروف الطريق.'
    },
    subject: 'Technology & Safety'
  }
  ,
  {
    id: 'q-ts-10',
    text: {
      en: 'What should you do when the ABS warning light stays on while driving?',
      nl: 'Wat moet u doen als het ABS-waarschuwingslampje tijdens het rijden brandend blijft?',
      ar: 'ماذا يجب أن تفعل إذا بقيت لمبة تحذير نظام ABS مضاءة أثناء القيادة؟'
    },
    options: [
      { id: 'q-ts-10o1', text: { en: 'Continue driving; ABS is optional', nl: 'Doorrijden; ABS is optioneel', ar: 'استمر في القيادة؛ نظام ABS ليس ضرورياً' } },
      { id: 'q-ts-10o2', text: { en: 'Have the ABS system checked as soon as possible', nl: 'Het ABS zo snel mogelijk laten controleren', ar: 'افحص نظام ABS في أقرب وقت ممكن' } },
      { id: 'q-ts-10o3', text: { en: 'Drive faster to reset the system', nl: 'Sneller rijden om het systeem te resetten', ar: 'قُد بسرعة أكبر لإعادة ضبط النظام' } }
    ],
    correctAnswerId: 'q-ts-10o2',
    explanation: {
      en: 'If the ABS warning light stays on, the anti-lock braking system may not work. Have it checked by a qualified mechanic as soon as possible. Normal braking still works but without ABS assistance.',
      nl: 'Als het ABS-waarschuwingslampje brandend blijft, werkt het antiblokkeersysteem mogelijk niet. Laat het zo snel mogelijk door een deskundige controleren. Normaal remmen gaat nog, maar zonder ABS-hulp.',
      ar: 'إذا بقيت لمبة تحذير ABS مضاءة، فقد لا يعمل نظام المكابح المانعة للانغلاق. اطلب فحصه بواسطة فني مؤهل في أقرب وقت. ستعمل المكابح العادية، لكن بدون مساعدة ABS.'
    },
    subject: 'Technology & Safety'
  }
  ,
  {
    id: 'q-ts-11',
    text: {
      en: 'What does a blind spot detection system typically warn you about?',
      nl: 'Waarvoor waarschuwt een dode-hoekdetectiesysteem u meestal?',
      ar: 'ما الذي يحذّرك به نظام اكتشاف النقاط العمياء عادةً؟'
    },
    options: [
      { id: 'q-ts-11o1', text: { en: 'Vehicles directly in front of you', nl: 'Voertuigen direct voor u', ar: 'مركبات أمامك مباشرة' } },
      { id: 'q-ts-11o2', text: { en: 'Vehicles in the area beside and behind your car that you may not see in the mirrors', nl: 'Voertuigen naast en achter uw auto die u in de spiegels niet ziet', ar: 'مركبات في المنطقة إلى جانبك وخلف سيارتك قد لا تراها في المرايا' } },
      { id: 'q-ts-11o3', text: { en: 'Pedestrians on the pavement', nl: 'Voetgangers op het trottoir', ar: 'المشاة على الرصيف' } }
    ],
    correctAnswerId: 'q-ts-11o2',
    explanation: {
      en: 'Blind spot detection warns of vehicles in the area beside and behind your car that may not be visible in the mirrors. Always still look over your shoulder before changing lanes.',
      nl: 'Dode-hoekdetectie waarschuwt voor voertuigen naast en achter uw auto die in de spiegels niet zichtbaar zijn. Kijk altijd nog over uw schouder voordat u van rijstrook wisselt.',
      ar: 'ينبّه اكتشاف النقاط العمياء إلى مركبات في المنطقة إلى جانب سيارتك وخلفها والتي قد لا تكون مرئية في المرايا. ومع ذلك يجب عليك دائماً النظر عبر الكتف قبل تغيير الحارة.'
    },
    subject: 'Technology & Safety'
  }
  ,
  {
    id: 'q-ts-12',
    text: {
      en: 'What does Lane Keep Assist (LKA) do?',
      nl: 'Wat doet Lane Keep Assist (LKA)?',
      ar: 'ماذا يفعل نظام الحفاظ على المسار (Lane Keep Assist - LKA)؟'
    },
    options: [
      { id: 'q-ts-12o1', text: { en: 'Warns you when you drift out of your lane', nl: 'Waarschuwt als u uit uw rijstrook raakt', ar: 'يُحذّرك عندما تخرج من حارتك' } },
      { id: 'q-ts-12o2', text: { en: 'Gently steers the car back into the lane if you drift without indicating', nl: 'Stuurt zacht bij terug naar de rijstrook als u zonder richtingaanwijzer wegzakt', ar: 'يتولى توجيه السيارة بلطف إلى داخل الحارة إذا انحرفت دون استخدام الإشارة' } },
      { id: 'q-ts-12o3', text: { en: 'Automatically changes lanes for you', nl: 'Wisselt automatisch van rijstrook voor u', ar: 'غيّر الحارات تلقائياً نيابةً عنك' } }
    ],
    correctAnswerId: 'q-ts-12o2',
    explanation: {
      en: 'Lane Keep Assist (LKA) gently applies steering correction to help keep the vehicle in the lane when it detects unintentional lane departure without use of the indicator.',
      nl: 'Lane Keep Assist (LKA) past zacht stuurcorrectie toe om het voertuig in de rijstrook te houden bij onbedoeld wegzakken zonder richtingaanwijzer.',
      ar: 'يساعد نظام الحفاظ على المسار (LKA) بتصحيح التوجيه بلطف للمساعدة في إبقاء السيارة داخل الحارة عند اكتشاف خروج غير مقصود من المسار دون استخدام الإشارة.'
    },
    subject: 'Technology & Safety'
  }
  ,
  {
    id: 'q-ts-13',
    text: {
      en: 'What does a red warning light on the dashboard usually indicate?',
      nl: 'Wat geeft een rood waarschuwingslampje op het dashboard meestal aan?',
      ar: 'ماذا يشير عادةً ظهور لمبة تحذير حمراء على لوحة القيادة؟'
    },
    options: [
      { id: 'q-ts-13o1', text: { en: 'A minor issue; you can continue your journey', nl: 'Een klein probleem; u kunt verder rijden', ar: 'مشكلة بسيطة؛ يمكنك متابعة الرحلة' } },
      { id: 'q-ts-13o2', text: { en: 'A serious problem; stop as soon as it is safe and check the vehicle', nl: 'Ernstig probleem; stop zodra het veilig is en controleer het voertuig', ar: 'مشكلة خطيرة؛ توقف حالما يكون ذلك آمناً وافحص السيارة' } },
      { id: 'q-ts-13o3', text: { en: 'The system is working correctly', nl: 'Het systeem werkt correct', ar: 'النظام يعمل بشكل صحيح' } }
    ],
    correctAnswerId: 'q-ts-13o2',
    explanation: {
      en: 'A red warning light usually indicates a serious problem that requires immediate attention. Stop as soon as it is safe to do so and check the vehicle before continuing.',
      nl: 'Een rood waarschuwingslampje duidt meestal op een ernstig probleem dat direct aandacht vereist. Stop zodra dat veilig kan en controleer het voertuig voordat u verder rijdt.',
      ar: 'تشير لمبة التحذير الحمراء عادةً إلى مشكلة خطيرة تتطلب اهتماماً فورياً. توقف حالما يكون ذلك آمناً وافحص السيارة قبل متابعة القيادة.'
    },
    subject: 'Technology & Safety'
  }
];

























